<div class="holiday-call-flow-form" data-automation="holiday-call-flow-form">
  <ziro-text [fieldId]="'name'" [inlineLabel]="false"></ziro-text>
  <ziro-select [fieldId]="'holidaySchedule'" [inlineLabel]="false"></ziro-select>

  @if (selectedDateRanges.length) {
    <div data-automation="holiday-date-ranges">
      <label class="col-form-label col-12 pb-0">
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.date_ranges.label' | translate }}
      </label>
      <ul class="list-unstyled mb-0">
        @for (range of selectedDateRanges; track $index) {
          <li class="py-2 small text-muted">
            {{ range.start | date: 'MMMM d, y, h:mm a' }} – {{ range.end | date: 'MMMM d, y, h:mm a' }}
          </li>
        }
      </ul>
    </div>
  }

  <div class="holiday-call-flow-form__actions gap-2">
    <ziro-button
      [label]="
        'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.add_holiday.label' | translate
      "
      [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
      [icon]="ZiroIcons.ADD"
      [buttonSize]="ButtonSizes.MEDIUM"
      (clicked)="openCreateHolidayModal()"
      dataAutomation="add-new-holiday-button"
    ></ziro-button>
    @if (formData?.holidaySchedule?.value) {
      <ziro-button
        [label]="
          'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.edit_holiday.label' | translate
        "
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [icon]="ZiroIcons.EDIT"
        [buttonSize]="ButtonSizes.MEDIUM"
        (clicked)="openEditHolidayModal()"
        dataAutomation="edit-holiday-button"
      ></ziro-button>
    }
  </div>
</div>
